export function hasParent(target: any, parent: HTMLDivElement) {
    return parent != null &&
        target != null &&
        (target === parent || hasParent(target.parentNode, parent));
}
